import React from "react";
import { authToken } from "constant";
import { Navigate } from "react-router-dom";

interface Props {
  children: React.ReactNode;
}

const ProtectedAuth: React.FC<Props> = ({ children }: Props) => {
  const token = localStorage.getItem(authToken);
  return !token ? <>{children}</> : <Navigate to="/" replace />;
};

export default ProtectedAuth;
